import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { colors, useAtSize, Caption } from '@fs/zion-ui'
import { Link } from '@fs/zion-router'
import ChurchLogo from './ChurchLogo'
import { useDataContext } from '../../services/data-service'

const footerCss = css`
  background: ${colors.gray00};
  min-height: 80px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const churchLogoCss = css`
  position: relative;
  margin-left: 24px;
`

export default function AncestorsFooter(): JSX.Element {
  const {
    store: { CF = false },
  } = useDataContext()
  const [t] = useTranslation()
  const atSize = useAtSize()
  const isMobile = atSize({ default: true, lg: false })

  const dateValues = { termsDate: '2019-12-10', privacyDate: '2021-04-06' }

  return (
    <footer css={footerCss}>
      <div>
        <Caption>
          {CF ? (
            t('ancestors.terms-privacy.restricted-text', dateValues)
          ) : (
            <Trans i18nKey="ancestors.terms-privacy.text" values={dateValues}>
              <Link to="https://www.familysearch.org/legal/terms" />
              <Link to="https://www.familysearch.org/legal/privacy" />
            </Trans>
          )}
        </Caption>
        <Caption>
          {CF ? (
            t('ancestors.intellectual-reserve.restricted-text')
          ) : (
            <Trans i18nKey="ancestors.intellectual-reserve.text">
              <Link to="https://www.churchofjesuschrist.org" />
            </Trans>
          )}
        </Caption>
      </div>
      {!isMobile && (
        <div css={churchLogoCss}>
          <ChurchLogo restricted={CF} />
        </div>
      )}
    </footer>
  )
}
